import React from 'react';

function MapControls({ onZoomIn, onZoomOut, onToggle3D, is3D }) {
  return (
    <div className="map-controls">
      {/* 3D Toggle Switch - Vertical with labels */}
      <div className="map-3d-toggle" title={is3D ? 'Switch to 2D view' : 'Switch to 3D view'}>
        <span className={`toggle-label ${!is3D ? 'active' : ''}`}>2D</span>
        <div
          className={`toggle-switch ${is3D ? 'active' : ''}`}
          onClick={onToggle3D}
          role="switch"
          aria-checked={is3D}
          aria-label="Toggle 3D view"
          tabIndex={0}
          onKeyDown={(e) => {
            if (e.key === 'Enter' || e.key === ' ') {
              e.preventDefault();
              onToggle3D();
            }
          }}
        >
          <div className="toggle-switch-knob" />
        </div>
        <span className={`toggle-label ${is3D ? 'active' : ''}`}>3D</span>
      </div>

      {/* Zoom Controls */}
      <button
        className="map-control-btn zoom-in"
        onClick={onZoomIn}
        aria-label="Zoom in"
        title="Zoom in"
      >
        <svg width="18" height="18" viewBox="0 0 18 18" fill="none">
          <path d="M9 3v12M3 9h12" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/>
        </svg>
      </button>
      <button
        className="map-control-btn zoom-out"
        onClick={onZoomOut}
        aria-label="Zoom out"
        title="Zoom out"
      >
        <svg width="18" height="18" viewBox="0 0 18 18" fill="none">
          <path d="M3 9h12" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/>
        </svg>
      </button>
    </div>
  );
}

export default MapControls;
